import BaseModelService from '../../base/base_model_service';
import Device from '../../utils/device/device';

class ResizeDetectorModel extends BaseModelService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ResizeDetectorModel';


    /**
     *
     */
    init() {
        this
            .setWidth(Device.viewport.width)
            .setHeight(Device.viewport.height);
    }


    /**
     *
     * @param width
     * @returns {ResizeDetectorModel}
     * @public
     */
    setWidth(width) {
        this._width = width;
        return this;
    }


    /**
     *
     * @param height
     * @returns {ResizeDetectorModel}
     * @public
     */
    setHeight(height) {
        this._height = height;
        return this;
    }


    /**
     *
     * @param orientation
     * @returns {ResizeDetectorModel}
     * @public
     */
    setOrientation(orientation) {
        this._orientation = orientation;
        return this;
    }


    /**
     *
     * @param deviceType
     * @returns {ResizeDetectorModel}
     */
    setDeviceType(deviceType) {
        this._deviceType = deviceType;
        return this;
    }


    /**
     *
     * @returns {*}
     * @public
     */
    getWidth() {
        return this._width;
    }


    /**
     *
     * @returns {*}
     * @public
     */
    getHeight() {
        return this._height;
    }


    /**
     *
     * @returns {*}
     * @public
     */
    getOrientation() {
        return this._orientation;
    }


    /**
     *
     * @returns {*}
     */
    getDeviceType() {
        return this._deviceType;
    }
}

export default ResizeDetectorModel;